import 'bootstrap/js/dist/collapse.js';
import 'bootstrap/js/dist/modal.js';
import FormBabyJourney from './landingpage/FormBabyJourney.mjs';
import FormUpdateChild from './landingpage/FormUpdateChild.mjs';

export default class Landingpage {
  constructor() {
    const $babyJourneyForm = $('form[name="form-baby-journey"]');
    if ($babyJourneyForm.length) {
      new FormBabyJourney({
        $form: $babyJourneyForm,
      })
    }

    const $updateChildForm = $('form[name="form-update-child"]');
    if ($updateChildForm.length) {
      new FormUpdateChild({
        $form: $updateChildForm,
      })
    }
  }
}
